import { render, staticRenderFns } from "./MyQualityManagement.vue?vue&type=template&id=b8dbe484&scoped=true&lang=html&"
import script from "./MyQualityManagement.vue?vue&type=script&lang=js&"
export * from "./MyQualityManagement.vue?vue&type=script&lang=js&"
import style0 from "./MyQualityManagement.vue?vue&type=style&index=0&id=b8dbe484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dbe484",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VCard,VCardActions,VCol,VDataTable,VIcon,VRow,VSpacer,VTextField})
